<template>
  <mdc-dialog class="bids-modal"
              v-model="isOpen"
              :title="'bids.request_new_protocol' | trans"
              @cancel="cancel"
              @close="cancel">

    <div class="close-cross" @click="cancel">
      <mdc-icon icon="close"></mdc-icon>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <mdc-textfield id="description"
                       :label="'bids.write_protocol_goal' | trans"
                       type="text"
                       name="description"
                       :class="{'is-invalid': errors.has('description')}"
                       v-model="description"
                       v-validate="'required|min:10|max:1000'"
                       data-vv-validate-on="none"
                       :data-vv-as="'bids.comment' | trans"
                       multiline rows="8" cols="40"/>

           <span class="invalid-feedback"
              v-if="errors.has('description')">
             <strong>{{ errors.first('description') }}</strong>
           </span>

        <p class="text-right">{{description.length}}/1000</p>
      </div>
    </div>


    <footer class="mdc-dialog__footer mdc-dialog__footer--visible">
      <button type="button" class="mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel"  @click="cancel"> {{'bids.buttons.cancel' | trans}}</button>

      <button type="button" class="mdc-button mdc-button--raised button-primary" @click="onSendRequestButtonClick()">
        <span v-if="isTherapist">{{'bids.buttons.sendRequest' | trans}}</span>
        <span v-else>{{'bids.buttons.sendRequest' | trans}}</span>
      </button>
    </footer>
  </mdc-dialog>
</template>

<script>
  import apiBids from '../api/bids';
  import {mapGetters, mapActions} from 'vuex';
  import lang from '../../../lang/translator';

  export default {
    name: 'BidsAddModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        description: '',
      };
    },
    methods: {
      ...mapActions('bids/list', [
        'setIsSaved',
      ]),

      onSendRequestButtonClick() {
        this.validate();
      },

      async sendRequest(apiManager, clientId) {
        try {
          let response =  await apiManager.create(
              clientId,
              this.description
          );

          this.close();
        } catch (e) {
          console.error('Unknown API error occurred.');
        } finally {
          this.setIsSaved(true);
          this.$emit('close');
        }
      },

      async validate() {
        let result = await this.$validator.validateAll();

        if (result) {
          this.sendRequest(apiBids, this.clientId);
        }
      },

      cancel() {
        this.description = '';
        this.$emit('cancel');
      },

      close() {
        this.description = '';
        this.$emit('close');
      },
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        }
      },
      ...mapGetters('auth', [
        'isTherapist'
      ])
    }
  };
</script>


// WEBPACK FOOTER //
// src/modules/bids/components/AddModal.vue